module.exports = __webpack_public_path__ + "img/about-m-banner.a975d77a.png";